<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">人员姓名：</div>
        <el-input
          placeholder="请输入人员姓名"
          v-model="queryInfo.empName"
          @change="GetPerson"
          clearable
          size="medium"
        >
        </el-input>
      </div>
      <div class="userNameSearch">
        <div class="searchTxt">人员编号:</div>
        <el-input
          placeholder="请输入人员编号"
          v-model="queryInfo.empNo"
          @change="GetPerson"
          clearable
          size="medium"
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位卡片区域 -->
      <div class="leftBox">
        <!-- 单位树 -->
        <el-tree
          class="treeBox"
          :data="depTrees"
          :props="defaultTreesProps"
           default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
      <!-- 右边人员卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加人员按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddUserDialogVisible = true"
          >
            新增
          </el-button>
          <!-- 人员信息表格区域 -->
          <el-table
            :data="userList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center',
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
            
          >
            <el-table-column prop="empName" label="人员姓名"> </el-table-column>
            <el-table-column prop="empNo" label="人员编号"> </el-table-column>
            <el-table-column prop="depName" label="所属项目"> </el-table-column>
            >
            <el-table-column label="操作" width="130">
              <template v-slot="slot">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="bottom-start"
                >
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="OpenUpdateUser(slot.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="DeleteUser(slot.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination" v-if="pageshow">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="queryInfo.page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="queryInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :key="key"
              background
            >
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </div>
    <!-- 添加人员对话框 -->
    <el-dialog
      title="添加人员"
      :visible.sync="AddUserDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddUserForm()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addUserFormRef"
        :rules="AddPersonInfoRules"
        :model="PersonInfo"
        label-width="80px"
      >
        <el-form-item prop="empName" label="人员姓名">
          <el-input
            placeholder="请输入人员姓名"
            v-model="PersonInfo.empName"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="empNo" label="人员编号">
          <el-input
            placeholder="请输入人员编号"
            v-model="PersonInfo.empNo"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="empDepId" label="所属项目">
          <el-select
            v-model="PersonInfo.empDepId"
            placeholder="请选择"
            ref="MySelect"
          >
            <el-option
              :key="PersonInfo.empDepId"
              :label="checkDname"
              :value="PersonInfo.empDepId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleNodeClick2"
            >
            </el-tree>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddUser()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改人员对话框 -->
    <el-dialog
      title="修改人员信息"
      :visible.sync="UpdateUserDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearUpdateUserForm()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="UpateUserFormRef"
        :rules="AddPersonInfoRules"
        :model="UpdateUserInfo"
        label-width="80px"
      >
        <el-form-item prop="empName" label="人员姓名">
          <el-input
            placeholder="请输入人员姓名"
            v-model="UpdateUserInfo.empName"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="empNo" label="人员编号">
          <el-input
            placeholder="请输入人员编号"
            v-model="UpdateUserInfo.empNo"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="empDepId" label="所属项目">
          <el-select
            v-model="UpdateUserInfo.empDepId"
            placeholder="请选择"
            ref="MyUpdateSelect"
          >
            <el-option
              :key="UpdateUserInfo.empDepId"
              :label="UpdateUserInfo.depName"
              :value="UpdateUserInfo.empDepId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleUpdateDepNodeClick"
            >
            </el-tree>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="UpdateUser()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 获取到的人员信息
      userList: [],
      // 人员总数
      total: 0,
      // 查询用户信息参数
      queryInfo: {
        // 人员姓名
        empName: "",
        // 人员编号
        empNo: "",
        // 单位ID
        depId: "",
        // 当前页码
        page: 1,
        // 每一页多少条
        pageSize: 10,
      },
      // 增加单位选中单位名称
      checkDname: "",
      pageshow: true,
      key: 0,
      // 单位信息
      depTrees: [],
      defaultTreesProps: {
        children: "depChilds",
        label: "depName",
      },
      // 添加人员对话框
      AddUserDialogVisible: false,
      // 人员实体
      PersonInfo: {
        // 人员编号
        empNo: "",
        // 人员姓名
        empName: "",
        // 所属单位id
        empDepId: "",
      },
      // 修改用户信息
      UpdateUserInfo: {
        // 人员id
        empId: "",
        // 人员编号
        empNo: "",
        // 人员姓名
        empName: "",
        // 所属单位id
        empDepId: "",
        // 单位名称
        depName: "",
      },
      // 修改选择柜门
      // 删除用户
      deleteUserInfo: {
        personId: "",
        empName: "",
      },
      // 修改用户信息对话框的显示与隐藏控制
      UpdateUserDialogVisible: false,
      // 表单验证规则
      AddPersonInfoRules: {
        empName: [
          { required: true, message: "请输入人员姓名", trigger: "blur" },
        ],
        empNo: [{ required: true, message: "请输入人员编号", trigger: "blur" }],
        empDepId: [
          { required: true, message: "请选择人员项目", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.GetPerson();
    this.GetAllDepTrees();
  },
  methods: {
    // 分页查询人员信息
    async GetPerson() {
      const { data: res } = await this.$axios.get(`${this.$api}/emp/search`, {
        params: this.queryInfo,
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }

      this.userList = res.data.rows;
      // 人员总数
      this.total = res.data.total;
    },
    // 获取全部单位树
    async GetAllDepTrees() {
      const { data: res } = await this.$axios.get(`${this.$api}/department/getDepTree`);
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.depTrees = res.data;
    },

    //  根据单位查询人员信息
    handleNodeClick(data) {
      this.queryInfo.depId = data.depId;
      this.GetPerson();
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.GetPerson();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryInfo.page = current;
      this.GetPerson();
    },
    // 添加人员
    AddUser() {
      this.$refs.addUserFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/emp/add`,
          this.PersonInfo
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("添加人员成功");
        this.AddUserDialogVisible = false;
        this.GetPerson();
      });
    },
    // 添加人员当选中单位时触发
    handleNodeClick2(data) {
      this.PersonInfo.empDepId = data.depId;
      this.checkDname = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MySelect.handleClose();
    },
    // 关闭添加人员对话框
    clearAddUserForm() {
      this.checkDname = "";
      this.$refs.addUserFormRef.resetFields();
    },
    // 打开修改用户信息对话框
    OpenUpdateUser(vule) {
      this.UpdateUserDialogVisible = true;
      // 人员ID
      this.UpdateUserInfo.empId = vule.empId;
      // 人员编号
      this.UpdateUserInfo.empNo = vule.empNo;
      // 人员名称
      this.UpdateUserInfo.empName = vule.empName;
      // 单位ID
      this.UpdateUserInfo.empDepId = vule.empDepId;
      // 单位名称
      this.UpdateUserInfo.depName = vule.depName;
    },

    // 修改当选中单位时触发
    handleUpdateDepNodeClick(data) {
      // 选中后的单位ID
      this.UpdateUserInfo.empDepId = data.depId;
      //选中后的单位名称
      this.UpdateUserInfo.depName = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MyUpdateSelect.handleClose();
    },
    //修改人员信息
    UpdateUser() {
      this.$refs.UpateUserFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.put(
          `${this.$api}/emp/modify/${this.UpdateUserInfo.empId}`,
          {
            empName: this.UpdateUserInfo.empName,
            empNo: this.UpdateUserInfo.empNo,
            empDepId: this.UpdateUserInfo.empDepId,
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("人员信息修改成功");
        this.UpdateUserDialogVisible = false;
        this.GetPerson();
      });
    },

    // 关闭修改人员对话框
    clearUpdateUserForm() {
      this.$refs.UpateUserFormRef.resetFields();
    },
    //删除人员信息
    async DeleteUser(vule) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该人员, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(`${this.$api}/emp/delete/${vule.empId}`);

      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("人员删除成功");
      this.GetPerson();
    },
  },
};
</script>

<style lang="less" scoped>
// 新增按钮
.add-btn {
  float: left;
  margin-bottom: 10px;
}

// 收缩框样式
.search {
  line-height: 60px;
}

.el-cascader {
  width: 100%;
}

.el-tag {
  margin: 5px;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 120px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}
// 下拉选择框
.el-select {
  width: 100%;
}

/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 40px 10px 20px 10px;
  height: calc(100vh - 220px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/SystemManagement/personnelManagement.vue